import React from 'react'

const CourseDetailLoading = () => {
    return (
        <div className="min-h-screen p-8 bg-gray-100 text-gray-900">
            <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden animate-pulse">
                {/* Course Image or image Placeholder */}
                <div className="bg-blue-200 h-80 w-full object-cover rounded-xl"></div>

                {/* Course Details Placeholder */}
                <div className="p-8">
                    {/* Course Title Placeholder */}
                    <div className="h-8 bg-blue-300 rounded mb-4 w-3/4 mx-auto"></div>

                    {/* Course Description Placeholder */}
                    <div className="space-y-4 mb-6">
                        <div className="h-4 bg-blue-200 rounded w-full"></div>
                        <div className="h-4 bg-blue-200 rounded w-5/6"></div>
                    </div>

                    {/* Course Category and Price Placeholder */}
                    <div className="flex justify-between items-center mb-6">
                        <div className="space-y-2">
                            <div className="h-4 bg-blue-200 rounded w-20"></div>
                            <div className="h-4 bg-blue-200 rounded w-32"></div>
                        </div>
                        <div className="space-y-2">
                            <div className="h-4 bg-blue-200 rounded w-20"></div>
                            <div className="h-4 bg-blue-200 rounded w-24"></div>
                        </div>
                    </div>

                    {/* Teachers Section Placeholder */}
                    <div className="mb-6">
                        <div className="h-6 bg-blue-300 rounded mb-4 w-1/4"></div>
                        <div className="flex flex-wrap items-center gap-6">
                            <div className="flex items-center space-x-4 bg-blue-100 p-4 rounded-lg shadow-md">
                                <div className="w-16 h-16 bg-blue-200 rounded-full"></div>
                                <div className="h-4 bg-blue-200 rounded w-32"></div>
                            </div>
                            <div className="flex items-center space-x-4 bg-blue-100 p-4 rounded-lg shadow-md">
                                <div className="w-16 h-16 bg-blue-200 rounded-full"></div>
                                <div className="h-4 bg-blue-200 rounded w-32"></div>
                            </div>
                        </div>
                    </div>

                    {/* Schedule Placeholder */}
                    <div className="space-y-4 mb-6">
                        <div className="h-4 bg-blue-200 rounded w-1/4"></div>
                        <div className="space-y-2">
                            <div className="h-4 bg-blue-200 rounded w-full"></div>
                            <div className="h-4 bg-blue-200 rounded w-3/4"></div>
                        </div>
                    </div>

                    {/* Classroom Selection Placeholder */}
                    <div className="mb-8">
                        <div className="h-6 bg-blue-300 rounded mb-4 w-1/3"></div>
                        <div className="h-12 bg-blue-200 rounded w-full"></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default CourseDetailLoading